import { type FirebaseServiceConfig } from '@client/store/firebaseStore';

const haewaoFirebaseConfig: FirebaseServiceConfig = {
    dev: {
        apiKey: 'AIzaSyBsqzSgRn_yyoj4pt5oHF6je8MkY0RSl7k',
        authDomain: 'haewao-firebase-dev.firebaseapp.com',
        projectId: 'haewao-firebase-dev',
        storageBucket: 'haewao-firebase-dev.firebasestorage.app',
        messagingSenderId: '678418872417',
        appId: '1:678418872417:web:416a6435cbe2ef44415220',
        measurementId: 'G-WW4BXSFLDB',
    },
    prod: {
        apiKey: 'AIzaSyAWTzWYkBkM6LmV7KJe29Iskl1sHpYQ33o',
        authDomain: 'haewao-firebase.firebaseapp.com',
        projectId: 'haewao-firebase',
        storageBucket: 'haewao-firebase.firebasestorage.app',
        messagingSenderId: '539450840893',
        appId: '1:539450840893:web:76716a8655600aa4aa1754',
        measurementId: 'G-8WD447V2WT',
    },
};

export default haewaoFirebaseConfig;
